export default __webpack_public_path__ + "static/media/cameragot-screenshot-01.eea6498e.png";